export default __webpack_public_path__ + "static/media/q28_step5.e40412cc.png";